import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Container, LoadingSpinner, CaptionText } from '@paypalcorp/pp-react';
import { loaderTypes } from '../common/constants';

// TODO:: These needs to be taken from translations as per locale
const screenReaderText = 'loading';
const defaultLoaderText = 'Your content is loading. Please wait';

const Loader = function (props) {
  const renderLoader = () => {
    const { loaderType, spinnerSize, customLoaderText } = props;
    switch (loaderType) {
      case loaderTypes.SPINNER: {
        return <LoadingSpinner screenReaderText={screenReaderText} size={spinnerSize} />;
      }

      case loaderTypes.TEXT: {
        return <CaptionText>{customLoaderText || defaultLoaderText}</CaptionText>;
      }

      case loaderTypes.SPINNER_WITH_TEXT: {
        return (
          <Fragment>
            <LoadingSpinner screenReaderText={screenReaderText} size={spinnerSize} />
            <CaptionText>{customLoaderText || defaultLoaderText}</CaptionText>
          </Fragment>
        );
      }

      default: {
        return <LoadingSpinner screenReaderText={screenReaderText} size={spinnerSize} />;
      }
    }
  };
  return <Container>{renderLoader()}</Container>;
};

Loader.propTypes = {
  loaderType: PropTypes.oneOf([loaderTypes.SPINNER, loaderTypes.TEXT]),
  spinnerSize: PropTypes.oneOf(['md', 'lg', 'xl']),
  customLoaderText: PropTypes.string,
};

Loader.defaultProps = {
  spinnerSize: 'lg',
  loaderType: loaderTypes.SPINNER,
};

export default Loader;
